// 按需引入 CryptoJS 需要的组件
const CryptoJS = require('crypto-js');
const Latin1 = require('crypto-js/enc-latin1');
const AES = require('crypto-js/aes');
const padPkcs7 = require('crypto-js/pad-pkcs7');
const Utf8 = require('crypto-js/enc-utf8');
const Base64 = require('crypto-js/enc-base64');
const sm3 = require('sm-crypto').sm3;
// 秘钥
const pubKey = 'zt/f1Nn3mBt7b1xB';
// ivKey
// const ivKey = 'OhFzMHWgINjnk3zN';
/*
 * 加密 解密
 */
// const getbaseCryptoCode = () => (window.localStorage.lotoken || '这一段文字用来做给路由加密的私钥').substring(0, 16);
// const baseCryptoCode = (window.localStorage.lotoken || '这一段文字用来做给路由加密的私钥').substring(0, 16); // 这个私钥每个项目指定一个唯一。更换密钥，请确认16位

const getKeyHex = cryptoCode => Latin1.parse(cryptoCode);

// const getIvHex = () => Latin1.parse(ivKey);

/**
 * 加密
 * @param {String} key
 * @param {String} cryptoCode
 * @returns {string}
 */
export const getEncrypt = (key, cryptoCode) => {
  let keyHex = getKeyHex(cryptoCode);
  try {
    key = JSON.stringify(key);
  } catch (e) {
    console.warn(e);
  }
  return AES.encrypt(key, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: padPkcs7
  }).toString();
};

/**
 * 加密后转base64
 * @param {String}} key
 */
export const getEncryptToBase64 = (key) => {
  let encryptStr = getEncrypt(key, pubKey);
  // console.log(encryptStr, 'encryptStr');
  // let wordArray = Utf8.parse(encryptStr);
  return encryptStr;
};

/**
 * 解密
 * @param data
 * @returns {string}
 */
export const getDecrypt = (data, cryptoCode) => {
  let keyHex = getKeyHex(cryptoCode);
  // let ivHex = getIvHex();
  let decrypted = AES.decrypt({
    ciphertext: Base64.parse(data)
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: padPkcs7
  }).toString(Utf8);
  try {
    decrypted = JSON.parse(decrypted);
  } catch (e) {
    console.warn(e);
  }
  return decrypted;
};

/**
 * 对base64数据解密  先解析base64，在做解密
 * @param {String} data
 * @returns {string}
 */
export const getDecryptByBase64 = data => {
  // let parsedWordArray = Base64.parse(data);
  // let decryptStr = parsedWordArray.toString(Utf8);
  return getDecrypt(data, pubKey);
};

/**
 *
 * @param {AxiosRequestConfig} config
 * @param {axios} axios
 * @returns {string}
 */
export const getSign = (config, axios, timestamp) => {
  let { method, data, params, headers, baseURL } = config;
  const requestURI = axios.getUri(config);
  // 过滤 query 中为 '', null, undefined, 'null', 'undefined' 的参数
  const sanitizedRequestURI = (() => {
    try {
      const [path, query] = requestURI.split('?');
      if (!query) return requestURI; // 无查询参数直接返回
      const filteredPairs = query
        .split('&')
        .filter(pair => {
          if (!pair) return false;
          const [rawKey, ...rawValueParts] = pair.split('=');
          if (!rawKey) return false;
          const rawValue = rawValueParts.join('=');
          const valueToCheck = rawValue === undefined ? '' : rawValue;
          return !(valueToCheck === '' || valueToCheck === 'undefined' || valueToCheck === 'null' || valueToCheck == null);
        });
      return filteredPairs.length ? `${path}?${filteredPairs.join('&')}` : path;
    } catch (e) {
      console.warn('sanitizeRequestURI error', e);
      return requestURI; // 解析失败回退原值
    }
  })();
  // 若首字符不是 '/' 补上，确保签名路径格式一致
  const normalizedRequestURI = sanitizedRequestURI.startsWith('/') ? sanitizedRequestURI : '/' + sanitizedRequestURI;
  let urlParam;
  if (method === 'get' || method === 'delete') {
    // urlParam = params || '';
    console.log('params', params);
    urlParam = '';
  } else if (method === 'post' || method === 'put') {
    // if ((headers['Content-Type'] && headers['Content-Type'].includes('application/json')) || (headers[method]['Content-Type'] && headers[method]['Content-Type'].includes('application/json'))) {
    if (headers['Content-Type'] && headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
      console.log('111');
    } else if (headers['Content-Type'] && headers['Content-Type'].includes('multipart/form-data')) {
      data = '';
    } else {
      data = JSON.stringify(data) || '';
    }
    // }
    urlParam = data || '';
  }
  let baseStr = baseURL.split('/');
  const signData = '/' + baseStr[baseStr.length - 2] + normalizedRequestURI + urlParam + timestamp;
  const sign = sm3(signData);
  return sign;
};
